<template>
  <div
    v-if="content.length === 1"
    id="single-line-container"
    class="container"
  >
    <p class="result-first-line">
      <template
        v-for="(pair, pairIndex) of highlightPairs[0]"
        :key="pairIndex"
      >
        {{ pair[0] }}<b>{{ pair[1] }}</b>
      </template>
    </p>
  </div>
  <div
    v-else-if="content.length > 1"
    id="multiple-line-container"
    class="container"
  >
    <div>
      <p
        v-for="(line, lineIndex) of highlightPairs"
        :key="lineIndex"
        :class="lineIndex === 0 ? 'result-first-line' : 'result-second-line'"
      >
        <template
          v-for="(pair, pairIndex) of line"
          :key="pairIndex"
        >
          {{ pair[0] }}<b>{{ pair[1] }}</b>
        </template>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // content is an array of Strings; each string is a line of text to be shown in the label
    content: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    /**
     * For each Array element in content, subdivide it into Arrays of pairs.
     * The first element of each pair is not highlighted, while the second element is.
     * @return {Array[]} - Each element is a line; each subarray element is [not highlighted, highlighted]
     * @example The input ['The <mark>North</mark> Office <mark>North</mark>Point'] becomes
     * [["The ", "North"], [" Office ", "North"], ["Point", ""]]
     */
    highlightPairs() {
      const result = [];
      const splitContent = this.content.map((x) => x.replace(/&amp;/g, '&').replace(/&#39;/g, '\'').split(/<mark>|<\/mark>/));
      splitContent.forEach((line) => {
        const pairs = [];
        let i = 0;
        while (i < line.length) {
          pairs.push(line.slice(i, i += 2));
        }
        result.push(pairs);
      });
      return result;
    },
  },
};
</script>

<style scoped lang="scss">
/* Necessary to ensure one-line labels center correctly */
p {
  font-size: 12px;
  line-height: 16px;
  max-height: 44px;
  margin-left: 4px;
  overflow: hidden;
}
.container {
  vertical-align: middle;
  height: 44px;
}
.container:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}
#single-line-container > p {
  display: inline-block;
  vertical-align: middle;
  white-space: normal;
}
#multiple-line-container > div {
  display: inline-block;
  vertical-align: middle;
}
#multiple-line-container > div > p {
  width: 250px;
  white-space: nowrap;
  overflow: hidden;
}
.result-first-line {
  color: main.$npGray;
}
.result-second-line {
  color: #667985
}
</style>
